export default {
	rtl: true,
	header: {
		title: 'حقيبة التسوق',
	},
	empty_cart: '',
	shipping_option: 'شحن عادي',
	product: {
		sold_out: 'غير متوفر',
	},
	product_details: {
		atcButton: { text: 'اضف الى حقيبة التسوق' },
		readMore: { text: 'اظهر المزيد' },
	},
	modules: {
		checkout_button: {
			button_text: { text: 'اتمام عملية الشراء' },
			button_text_loading: { text: 'اتمام عملية الشراء' },
			use_coupon_code: { text: 'كوبون خصم' },
			enter_coupon_code: { text: 'ادخل الكود ان كان لديك كوبون خصم' },
			apply_coupon_code: { text: 'استخدام' },
			edit_coupon_code: { text: 'تعديل' },
			close_coupon_code: { text: 'اغلاق' },
			subtotal: { text: 'المجموع' },
			savings: { text: 'التوفير' },
			coupon_alert_text: { text: 'كود الخصم يلغي بقية العروض' },
		},
		random_text: {
			text: '<p class="ql-align-center">100% NO-RISK MONEY BACK GUARANTEE</p>',
		},
		order_note: {
			text: '<p> <strong>Add a note to your order</strong></p>',
		}
	},
	campaigns: {
		bundles: {
			text: 'إشتري {{quantity}} و وفر {{discount}}',
			prefix: '{{individual_price}} للوحدة',
		},
		add_to_unlock: {
			title: {
				text: 'منتجات ممكن أن تعجبك',
			},

			show_product_details: {
				text: 'أظهر المزيد',
			},
			upsell_add_button: {
				text: 'أضف إلى حقيبة التسوق',
			},
			upsell_confirm_button: {
				text: 'تأكيد',
			},
			discount: {
				before:
					"<p class='ql-align-center'><img src='https://www.amabattery.co.za/wpimages/wp4cb45f10.gif'> أظف <b>{{amount_left}}</b> للحصول على تخفيض <b>{{award}}</b><p>",
				after:
					"<p class='ql-align-center'><img src='https://media.giphy.com/media/1wX5TJZPqVw3HhyDYn/giphy.gif'> لقد حصلت على تخفيض <b>{{reward}}</b><p>",
			},
			free_shipping: {
				before:
					"<p class='ql-align-center'><img src='https://www.amabattery.co.za/wpimages/wp4cb45f10.gif'>  أظف <b>{{amount_left}}</b> للحصول على <b>شحن مجاني</b><p>",
				after:
					"<p class='ql-align-center'><img src='https://media.giphy.com/media/1wX5TJZPqVw3HhyDYn/giphy.gif'> لقد حصلت على <b>شحن مجاني</b><p>",
			},
			separator: {
				text: 'أو',
			},
			gift: {
				before:
					"<p class='ql-align-center'><img src='https://www.amabattery.co.za/wpimages/wp4cb45f10.gif'> Add <b>{{amount_left}}</b> to get a <b>Free Gift</b><p>",
				after:
					"<p class='ql-align-center'><img src='https://media.giphy.com/media/1wX5TJZPqVw3HhyDYn/giphy.gif'> You've unlocked a <b>Free Gift</b><p>",
				compare_at_price: {
					text: "{{compare_at_price}}"
				},
				widget: {
					before: {
						header:
							"Spend {{goal}} Get A Free Gift 🎁",
						product_name: "Free gift: {{product_name}}",
						offer_highlight: {
							text: "Free"
						},
					},
					after: {
						header:
							"Hurry! This offer is only valid today! ⏰",
						product_name: "<p><b>You unlocked this! 🎉</b></p><p>Free gift: {{product_name}}</p>",
						offer_highlight: {
							text: "Free"
						},
					}

				}
			}
		},
		one_check_up_sell: {
			text: '<p>🔥 أظف {{title}} مقابل {{price}}</p>',
		},
	},
};
